module.exports = __webpack_public_path__ + "media/images/lp/lp07-8e9ade1e0fe01480f628a74003d0ea8a.webp";